import React, { useState, Suspense, lazy } from "react";
import { HashRouter, Routes, Route, Navigate } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import Login from "./Login";
import Homepage from "./Homepage"; // importa il componente

// Caricate solo quando si visita la rotta: le dashboard si portano dietro le librerie
// pesanti (jsPDF, xlsx, lettore QR) che non servono a chi apre solo la homepage.
const Dashboard = lazy(() => import("./Dashboard"));
const Register = lazy(() => import("./Register"));
const ThankYou = lazy(() => import("./ThankYou"));
const ForgotPassword = lazy(() => import("./ForgotPassword"));
const ResetPassword = lazy(() => import("./ResetPassword"));
const Privacy = lazy(() => import("./Privacy"));

const Caricamento = () => (
  <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "60vh" }}>
    <CircularProgress sx={{ color: "#670058" }} />
  </Box>
);




function App() {
  const [token, setToken] = useState(localStorage.getItem("token"));
  const [role, setRole] = useState(localStorage.getItem("role"));

  const saveToken = (token, role) => {
    localStorage.setItem("token", token);
    localStorage.setItem("role", role);
    setToken(token);
    setRole(role);
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    setToken(null);
    setRole(null);
  };


  return (
    <HashRouter>
      <Suspense fallback={<Caricamento />}>
      <Routes>
        <Route path="/" element={<Homepage token={token} role={role} logout={logout} />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        <Route path="/privacy" element={<Privacy />} />

        {!token ? (
          <>
            <Route path="/login" element={<Login saveToken={saveToken} />} />
            <Route path="/register" element={<Register />} />
            <Route path="/thanks" element={<ThankYou />} />
            <Route path="*" element={<Navigate to="/" />} />  {/* redirect alla homepage */}
            
          </>
        ) : (
          <>
            <Route path="/dashboard/*" element={<Dashboard role={role} logout={logout} />} />
            <Route path="*" element={<Navigate to="/" />} />
          </>
        )}
      </Routes>
      </Suspense>
    </HashRouter>
  );
}

export default App;
